import FirstFactor from "./FirstFactor";
import FirstFactorCode from "./FirstFactorCode";
import FirstFactorPassword from "./FirstFactorPassword";
import FullName from "./FullName";
import NetworkSelect from "./NetworkSelect";
import Pending from "./Pending";
import Redirect from "./Redirect";
import SecondFactorCode from "./SecondFactorCode";

const componentKeys = {
  FirstFactor: "FirstFactor",
  FirstFactorCode: "FirstFactorCode",
  FirstFactorPassword: "FirstFactorPassword",
  SecondFactorCode: "SecondFactorCode",
  NetworkSelect: "NetworkSelect",
  Redirect: "Redirect",
  FullName: "FullName",
  Pending: "Pending",
};

const allComponentsConfig = [
  { key: componentKeys.FirstFactor, value: FirstFactor },
  { key: componentKeys.FirstFactorPassword, value: FirstFactorPassword },
  { key: componentKeys.FirstFactorCode, value: FirstFactorCode },
  { key: componentKeys.SecondFactorCode, value: SecondFactorCode },
  { key: componentKeys.NetworkSelect, value: NetworkSelect },
  { key: componentKeys.Redirect, value: Redirect },
  { key: componentKeys.FullName, value: FullName },
  { key: componentKeys.Pending, value: Pending },
];

const useComponentsConfig = () => {
  return allComponentsConfig;
};

export { componentKeys, useComponentsConfig };
